"use strict";

var _interopRequireWildcard3 = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PricingCard = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _interopRequireWildcard2 = _interopRequireDefault(require("@babel/runtime/helpers/interopRequireWildcard"));

var _react = _interopRequireWildcard3(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _Card = _interopRequireDefault(require("@material-ui/core/Card"));

var _CardContent = _interopRequireDefault(require("@material-ui/core/CardContent"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _core = require("@material-ui/core");

var _CardHeader = _interopRequireDefault(require("@material-ui/core/CardHeader"));

var _n = require("@mui-treasury/styles/textInfoContent/n01");

var _TextInfo = _interopRequireDefault(require("../../../../components/PageGrid/atoms/TextInfo/TextInfo"));

var _customComponents = require("../../../../utils/customComponents");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var CardActions = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../../../components/PageGrid/molecules/CardActions/CardActions"));
  });
});
var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    root: {
      borderRadius: 12,
      minWidth: 256,
      textAlign: 'center'
    },
    header: {
      textAlign: 'center',
      spacing: 10
    },
    list: {
      padding: '20px'
    },
    button: {
      margin: theme.spacing(1)
    },
    action: {
      display: 'flex',
      justifyContent: 'space-around'
    }
  };
});

var PricingCard = /*#__PURE__*/_react.default.memo(function (_ref) {
  var title = _ref.title,
      subTitle = _ref.subTitle,
      cardActions = _ref.cardActions,
      overline = _ref.overline,
      heading = _ref.heading,
      body = _ref.body,
      dataBlokC = _ref.dataBlokC,
      dataBlokUid = _ref.dataBlokUid,
      storyblokClass = _ref.storyblokClass;
  var classes = useStyles();
  var textCardContentStyles = (0, _n.useN01TextInfoContentStyles)();
  var actions = cardActions[0];
  return /*#__PURE__*/_react.default.createElement(_Card.default, {
    className: (0, _clsx.default)(classes.root, storyblokClass),
    "data-blok-c": dataBlokC,
    "data-blok-uid": dataBlokUid
  }, /*#__PURE__*/_react.default.createElement(_CardHeader.default, {
    title: title,
    className: classes.header
  }), /*#__PURE__*/_react.default.createElement(_core.Divider, {
    variant: "middle"
  }), /*#__PURE__*/_react.default.createElement(_CardContent.default, null, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "h4",
    align: "center"
  }, subTitle), /*#__PURE__*/_react.default.createElement(_TextInfo.default, {
    classes: textCardContentStyles,
    overline: overline,
    heading: heading,
    body: body
  })), /*#__PURE__*/_react.default.createElement(_core.Divider, {
    variant: "middle"
  }), actions ? /*#__PURE__*/_react.default.createElement(_react.Suspense, {
    fallback: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null)
  }, (0, _customComponents.renderComponentsWithBridge)({
    CardActions: CardActions
  }, _objectSpread(_objectSpread({}, actions), {}, {
    style: {
      display: 'flex',
      justifyContent: 'space-around'
    }
  }))) : null);
});

exports.PricingCard = PricingCard;
var _default = PricingCard;
exports.default = _default;
PricingCard.propTypes = {
  /** overline heading  */
  title: _propTypes.default.string.isRequired,

  /** overline body  */
  subTitle: _propTypes.default.string.isRequired,

  /** actions to add in card */
  cardActions: _propTypes.default.arrayOf(_propTypes.default.shape()),

  /** overline text */
  overline: _propTypes.default.string.isRequired,

  /** overline heading  */
  heading: _propTypes.default.string.isRequired,

  /** overline body  */
  body: _propTypes.default.string.isRequired,

  /** storyblok prop for when in editor to allow click bridge */
  dataBlokC: _propTypes.default.string,

  /** storyblok prop for when in editor to allow click bridge */
  dataBlokUid: _propTypes.default.string,

  /** storyblok prop for when in editor to allow click bridge */
  storyblokClass: _propTypes.default.string
};
PricingCard.defaultProps = {
  cardActions: [],
  dataBlokC: '',
  dataBlokUid: '',
  storyblokClass: ''
};